export function getCurrentPageAfterDeleting({ page, total, pageSize }, deletedItemCount = 1) {
  return Math.ceil((total - deletedItemCount) / pageSize) < page ? page - 1 : page;
}
